import { RADIO_BUTTONS_CF_TYPE } from '@atlassian/jira-platform-field-config';

export const radioSelectColumnWidth = {
	[RADIO_BUTTONS_CF_TYPE]: 160,
};
